import { takeEvery, fork, put, all, call, select } from 'redux-saga/effects';

import { GET_USERS } from './actionTypes';
import {
    getUsersSuccess,
    getUsersFailed
} from './actions';
import { paramGet } from '../../../apiHelpers/commonApiHelper';
import toastr from 'toastr';

function* getAllUsers({payload}) {
    // console.log("Pages ===", {payload)
    try {
        const response = yield call(paramGet, '/api/v1/admin', payload);
        console.log("response ===", response);
        if(response.status === 200) {
            yield put(getUsersSuccess(response.data));
        } else {
            yield put(getUsersFailed());
        }

    } catch (error) {
        yield put(getUsersFailed());
    }
}


export function* watchGetUsers() {
    yield takeEvery(GET_USERS, getAllUsers)
}

function* AdminSaga() {
    yield all([
        fork(watchGetUsers)
    ]);
}

export default AdminSaga;